import React, { useState } from 'react';
import { KeyRound, LogOut, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function TrainerInfo({ trainer, gym }) {
  const { signOut, user, updatePassword } = useAuth();
  const [showPwForm, setShowPwForm] = useState(false);
  const [newPw, setNewPw] = useState('');
  const [newPwConfirm, setNewPwConfirm] = useState('');
  const [pwError, setPwError] = useState('');
  const [pwLoading, setPwLoading] = useState(false);
  const [pwSuccess, setPwSuccess] = useState(false);

  async function handlePasswordChange(e) {
    e.preventDefault();
    setPwError('');
    if (newPw !== newPwConfirm) { setPwError('비밀번호가 일치하지 않습니다.'); return; }
    if (newPw.length < 6) { setPwError('비밀번호는 6자 이상이어야 합니다.'); return; }
    setPwLoading(true);
    const { error } = await updatePassword(newPw);
    setPwLoading(false);
    if (error) { setPwError('비밀번호 변경에 실패했습니다.'); return; }
    setPwSuccess(true);
    setNewPw(''); setNewPwConfirm('');
    setTimeout(() => { setPwSuccess(false); setShowPwForm(false); }, 2000);
  }

  return (
    <div className="p-4 space-y-4">
      <h2 className="text-lg font-bold text-gray-900 dark:text-white">내 정보</h2>

      {/* 프로필 카드 */}
      <div className="card p-5">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
            <User className="w-8 h-8 text-blue-500" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-gray-900 dark:text-white text-lg">{trainer?.name}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400">{gym?.name}</p>
          </div>
        </div>
        {trainer?.specialty && (
          <p className="text-sm text-gray-600 dark:text-gray-400">전문분야: {trainer.specialty}</p>
        )}
        {trainer?.phone && (
          <p className="text-sm text-gray-500 dark:text-gray-500 mt-1">{trainer.phone}</p>
        )}
      </div>

      {/* 계정 정보 */}
      <div className="card p-5 space-y-3">
        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">계정 정보</p>
        <p className="text-sm text-gray-500 dark:text-gray-400">{user?.email}</p>
        {!showPwForm ? (
          <button
            onClick={() => { setShowPwForm(true); setPwError(''); setPwSuccess(false); }}
            className="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 hover:underline"
          >
            <KeyRound className="w-3.5 h-3.5" /> 비밀번호 변경
          </button>
        ) : (
          <form onSubmit={handlePasswordChange} className="space-y-2 pt-1">
            <input
              type="password"
              className="w-full px-3 py-2 text-sm rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="새 비밀번호 (6자 이상)"
              value={newPw}
              onChange={e => setNewPw(e.target.value)}
              required
            />
            <input
              type="password"
              className="w-full px-3 py-2 text-sm rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="새 비밀번호 확인"
              value={newPwConfirm}
              onChange={e => setNewPwConfirm(e.target.value)}
              required
            />
            {pwError && <p className="text-xs text-red-500">{pwError}</p>}
            {pwSuccess && <p className="text-xs text-green-600 dark:text-green-400">비밀번호가 변경되었습니다.</p>}
            <div className="flex gap-2">
              <button type="button" onClick={() => setShowPwForm(false)} className="flex-1 py-2 rounded-xl border border-gray-200 dark:border-gray-600 text-xs text-gray-600 dark:text-gray-400">취소</button>
              <button type="submit" disabled={pwLoading} className="flex-1 py-2 rounded-xl bg-blue-600 text-white text-xs font-medium disabled:opacity-60">
                {pwLoading ? '변경 중...' : '변경'}
              </button>
            </div>
          </form>
        )}
      </div>

      {/* 로그아웃 */}
      <button
        onClick={signOut}
        className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 text-sm font-medium hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
      >
        <LogOut className="w-4 h-4" />
        로그아웃
      </button>
    </div>
  );
}
